export default __webpack_public_path__ + "static/media/opinion4.19fd2c82.jpg";